import { useEffect, useState } from 'react';
import {
  PossibleCompetitorDetailResponse,
  getPossibleCompetitorDetail,
  peekPossibleCompetitorDetail,
} from 'services/actions/ai_management_possible_competitors';

export function usePossibleCompetitorDetail(
  biddingId: number | null,
  historicBiddingId: number,
  item: string,
  cnpj: string,
) {
  const peek = () =>
    biddingId ? peekPossibleCompetitorDetail(biddingId, historicBiddingId, item, cnpj) : undefined;
  const [detail, setDetail] = useState<PossibleCompetitorDetailResponse | null>(
    () => peek()?.data ?? null,
  );
  const [loading, setLoading] = useState(() => !peek());
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!biddingId) {
      setLoading(false);
      setError(true);
      return undefined;
    }

    const hit = peek();
    if (hit) {
      setDetail(hit.data);
      setLoading(false);
      setError(false);
      return undefined;
    }

    let active = true;
    setLoading(true);
    setError(false);
    setDetail(null);

    getPossibleCompetitorDetail(biddingId, historicBiddingId, item, cnpj)
      .then(({ data }) => {
        if (!active) return;
        setDetail(data);
        setLoading(false);
      })
      .catch(() => {
        if (!active) return;
        setError(true);
        setLoading(false);
      });

    return () => {
      active = false;
    };
  }, [biddingId, historicBiddingId, item, cnpj]);

  return { detail, loading, error };
}
